import { styled } from "@material-ui/core";
import { EPOCUS_TEXT_PRIMARY, rem } from "../../_lib/epocus-palette";

export const AdminSectionHeading = styled("h2")({
  margin: 0,
  marginTop: 8,
  fontSize: rem(13),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});
